<!-- Hero -->
<section class="hero">
  <div class="hero-inner">
    <div class="hero-text">
      <p class="hero-greeting">Welcome back,</p>
      <h1>{{ firstName }} {{ lastName }}</h1>
      <div class="hero-meta">
        <span class="hero-badge"><mat-icon>business</mat-icon>{{ company }}</span>
        <span class="hero-badge"><mat-icon>calendar_today</mat-icon>{{ today }}</span>
      </div>
    </div>
  </div>
</section>

<div class="dashboard">

  <!-- Request Command Center -->
  <section class="command-center">

    <!-- Header -->
    <div class="cc-header">
      <div class="cc-title">
        <div class="cc-title-icon">
          <img *ngIf="companyLogo" [src]="companyLogo" alt="Company" class="cc-title-logo">
          <mat-icon *ngIf="!companyLogo">hub</mat-icon>
        </div>
        <div>
          <h2>{{ selectedProjectName || 'All Projects' }}</h2>
          <p>Real-time request status overview</p>
        </div>
      </div>
      <div class="cc-header-right">
        <div class="cc-total-badge">
          <span class="cc-total-value">{{ totalRequestCount }}</span>
          <span class="cc-total-label">Total</span>
        </div>
      </div>
    </div>

    <!-- Pipeline Stages -->
    <div class="cc-pipeline">

      <!-- Action Required -->
      <a class="cc-stage stage-action" routerLink="/requests" [queryParams]="{stage: 'Action Required'}" *ngIf="canViewRequests()">
        <div class="cc-stage-ring" [class.ring-pulse]="stageActionRequiredCount > 0">
          <div class="cc-stage-circle"><mat-icon>error_outline</mat-icon></div>
        </div>
        <span class="cc-stage-count">{{ stageActionRequiredCount }}</span>
        <span class="cc-stage-pct" *ngIf="totalRequestCount > 0">{{ getStagePercentage(stageActionRequiredCount) }}%</span>
        <span class="cc-stage-label">Action Required</span>
        <div class="cc-stage-bar"><div class="cc-bar-fill" [style.width.%]="getStagePercentage(stageActionRequiredCount)"></div></div>
      </a>

      <div class="cc-arrow"><mat-icon>chevron_right</mat-icon></div>

      <!-- Acknowledged -->
      <a class="cc-stage stage-ack" routerLink="/requests" [queryParams]="{stage: 'Acknowledged'}" *ngIf="canViewRequests()">
        <div class="cc-stage-ring">
          <div class="cc-stage-circle"><mat-icon>mark_email_read</mat-icon></div>
        </div>
        <span class="cc-stage-count">{{ stageAcknowledgedCount }}</span>
        <span class="cc-stage-pct" *ngIf="totalRequestCount > 0">{{ getStagePercentage(stageAcknowledgedCount) }}%</span>
        <span class="cc-stage-label">Acknowledged</span>
        <div class="cc-stage-bar"><div class="cc-bar-fill" [style.width.%]="getStagePercentage(stageAcknowledgedCount)"></div></div>
      </a>

      <div class="cc-arrow"><mat-icon>chevron_right</mat-icon></div>

      <!-- In Progress -->
      <a class="cc-stage stage-prog" routerLink="/requests" [queryParams]="{stage: 'In Progress'}" *ngIf="canViewRequests()">
        <div class="cc-stage-ring">
          <div class="cc-stage-circle"><mat-icon>autorenew</mat-icon></div>
        </div>
        <span class="cc-stage-count">{{ stageInProgressCount }}</span>
        <span class="cc-stage-pct" *ngIf="totalRequestCount > 0">{{ getStagePercentage(stageInProgressCount) }}%</span>
        <span class="cc-stage-label">In Progress</span>
        <div class="cc-stage-bar"><div class="cc-bar-fill" [style.width.%]="getStagePercentage(stageInProgressCount)"></div></div>
      </a>

      <div class="cc-arrow"><mat-icon>chevron_right</mat-icon></div>

      <!-- Completed -->
      <a class="cc-stage stage-done" routerLink="/requests" [queryParams]="{stage: 'Complete'}" *ngIf="canViewRequests()">
        <div class="cc-stage-ring">
          <div class="cc-stage-circle"><mat-icon>check_circle_outline</mat-icon></div>
        </div>
        <span class="cc-stage-count">{{ stageCompleteCount }}</span>
        <span class="cc-stage-pct" *ngIf="totalRequestCount > 0">{{ getStagePercentage(stageCompleteCount) }}%</span>
        <span class="cc-stage-label">Completed</span>
        <div class="cc-stage-bar"><div class="cc-bar-fill" [style.width.%]="getStagePercentage(stageCompleteCount)"></div></div>
      </a>

    </div>

    <!-- Flow Distribution Bar -->
    <div class="cc-flow">
      <div class="cc-flow-header">
        <span class="cc-flow-title">Distribution</span>
        <div class="cc-flow-legend">
          <span class="legend-item legend-action"><span class="legend-dot"></span>Action</span>
          <span class="legend-item legend-ack"><span class="legend-dot"></span>Acknowledged</span>
          <span class="legend-item legend-prog"><span class="legend-dot"></span>In Progress</span>
          <span class="legend-item legend-done"><span class="legend-dot"></span>Completed</span>
        </div>
      </div>
      <div class="cc-flow-track" *ngIf="totalRequestCount > 0">
        <div class="cc-flow-seg seg-action" [style.flex-grow]="stageActionRequiredCount" [matTooltip]="stageActionRequiredCount + ' Action Required (' + getStagePercentage(stageActionRequiredCount) + '%)'"></div>
        <div class="cc-flow-seg seg-ack" [style.flex-grow]="stageAcknowledgedCount" [matTooltip]="stageAcknowledgedCount + ' Acknowledged (' + getStagePercentage(stageAcknowledgedCount) + '%)'"></div>
        <div class="cc-flow-seg seg-prog" [style.flex-grow]="stageInProgressCount" [matTooltip]="stageInProgressCount + ' In Progress (' + getStagePercentage(stageInProgressCount) + '%)'"></div>
        <div class="cc-flow-seg seg-done" [style.flex-grow]="stageCompleteCount" [matTooltip]="stageCompleteCount + ' Completed (' + getStagePercentage(stageCompleteCount) + '%)'"></div>
      </div>
      <div class="cc-flow-track cc-flow-empty" *ngIf="totalRequestCount === 0">
        <div class="cc-flow-seg seg-empty" style="flex-grow: 1"></div>
      </div>
    </div>

    <!-- Summary Strip -->
    <div class="cc-summary">
      <a class="cc-tile tile-projects" routerLink="/projects" *ngIf="canViewProjects()">
        <div class="cc-tile-icon icon-brand">
          <img *ngIf="companyLogo" [src]="companyLogo" alt="Company" class="cc-tile-logo">
          <mat-icon *ngIf="!companyLogo">business</mat-icon>
        </div>
        <div class="cc-tile-data">
          <span class="cc-tile-value">{{ projectCount }}</span>
          <span class="cc-tile-label">Projects</span>
        </div>
      </a>
      <div class="cc-tile tile-rate" (click)="showResponseRateModal = true" style="cursor:pointer">
        <div class="cc-tile-icon icon-rate"><mat-icon>speed</mat-icon></div>
        <div class="cc-tile-data">
          <span class="cc-tile-value">{{ responseRate }}<span class="cc-tile-unit">%</span></span>
          <span class="cc-tile-label">Response Rate</span>
        </div>
      </div>
      <a class="cc-tile tile-open" routerLink="/requests" [queryParams]="{status: 'Open'}" *ngIf="canViewRequests()">
        <div class="cc-tile-icon icon-open"><mat-icon>pending_actions</mat-icon></div>
        <div class="cc-tile-data">
          <span class="cc-tile-value">{{ unansweredRequestCount }}</span>
          <span class="cc-tile-label">Open</span>
        </div>
      </a>
      <a class="cc-tile tile-closed" routerLink="/requests" [queryParams]="{status: 'Closed'}" *ngIf="canViewRequests()">
        <div class="cc-tile-icon icon-closed"><mat-icon>task_alt</mat-icon></div>
        <div class="cc-tile-data">
          <span class="cc-tile-value">{{ closedRequestCount }}</span>
          <span class="cc-tile-label">Closed</span>
        </div>
      </a>
    </div>

    <!-- Integrated Quick Actions -->
    <div class="cc-actions">
      <a class="cc-action" routerLink="/projects/create" *ngIf="canCreateProjects()">
        <mat-icon>add_circle_outline</mat-icon><span>New Project</span>
      </a>
      <a class="cc-action" routerLink="/requests/create" *ngIf="canCreateRequests()">
        <mat-icon>post_add</mat-icon><span>New Request</span>
      </a>
      <a class="cc-action" routerLink="/requests/create" *ngIf="canCreateIQs()">
        <mat-icon>post_add</mat-icon><span>New IQ</span>
      </a>
      <a class="cc-action" routerLink="/timesheet" *ngIf="canViewTimesheet()">
        <mat-icon>schedule</mat-icon><span>Timesheet</span>
      </a>
      <a class="cc-action" routerLink="/requests" *ngIf="canViewRequests()">
        <mat-icon>visibility</mat-icon><span>View Requests</span>
      </a>
      <a class="cc-action" routerLink="/projects" *ngIf="canViewProjects()">
        <mat-icon>folder_open</mat-icon><span>View Projects</span>
      </a>
    </div>

  </section>

  <!-- Recent Activity -->
  <section class="activity-card">
    <div class="activity-header">
      <div class="activity-title">
        <div class="activity-title-icon"><mat-icon>history</mat-icon></div>
        <div>
          <h2>Recent Activity</h2>
          <p>Latest updates across your projects</p>
        </div>
      </div>
    </div>

    <div *ngIf="recentActivity.length; else noActivity" class="activity-content">

      <!-- Invoices activity column (COMMENTED OUT)
      <div class="activity-col" *ngIf="canViewInvoices()">
        <div class="col-head col-invoices"><mat-icon>receipt_long</mat-icon><span>Invoices</span></div>
        <div class="activity-timeline">
          <div class="timeline-item" *ngFor="let item of getActivitiesByType('Invoice')" (click)="navigateToActivity(item)">
            <div class="timeline-dot"></div>
            <div class="timeline-card">
              <div class="timeline-user" *ngIf="userCache.get(item.createdBy) as user">
                <img [src]="user.profilePhoto" class="avatar"
                     [routerLink]="['/user-profile', item.createdBy]"
                     (click)="$event.stopPropagation()"
                     [matTooltip]="'View ' + user.username + '\'s profile'">
                <span class="timeline-name">{{ user.firstname && user.lastname ? user.firstname + ' ' + user.lastname : user.username }}</span>
              </div>
              <div class="timeline-body">
                <strong>{{ item.description }}</strong>
                <div class="timeline-meta">
                  <span class="meta-badge meta-date"><mat-icon>schedule</mat-icon>{{ item.activityDate | date:'dd MMM yyyy' }}</span>
                  <span class="meta-badge meta-project"><mat-icon>folder</mat-icon>Proj #{{ item.projectNumber }}</span>
                </div>
              </div>
              <mat-icon class="timeline-chevron">chevron_right</mat-icon>
            </div>
          </div>
          <div class="timeline-empty" *ngIf="getActivitiesByType('Invoice').length === 0">No recent invoices</div>
        </div>
      </div>
      -->

      <!-- RFI -->
      <div class="activity-col" *ngIf="canViewRequests()">
        <div class="col-head col-requests"><mat-icon>description</mat-icon><span>RFI</span></div>
        <div class="activity-timeline">
          <div class="timeline-item" *ngFor="let item of getActivitiesByType('RFI')" (click)="navigateToActivity(item)">
            <div class="timeline-dot"></div>
            <div class="timeline-card">
              <div class="timeline-card-header">
                <div class="timeline-user" *ngIf="userCache.get(item.createdBy) as user">
                  <img [src]="user.profilePhoto" class="avatar"
                       [routerLink]="['/user-profile', item.createdBy]"
                       (click)="$event.stopPropagation()"
                       [matTooltip]="'View ' + user.username + '\'s profile'">
                  <span class="timeline-name">{{ user.firstname && user.lastname ? user.firstname + ' ' + user.lastname : user.username }}</span>
                </div>
              </div>
              <div class="timeline-body">
                <strong>{{ item.description }}</strong>
                <div class="timeline-meta">
                  <span class="meta-badge meta-date"><mat-icon>schedule</mat-icon>{{ item.activityDate | date:'dd MMM yyyy' }}</span>
                  <span class="meta-badge meta-project"><mat-icon>folder</mat-icon>Proj #{{ item.projectNumber }}</span>
                </div>
              </div>
              <mat-icon class="timeline-chevron">chevron_right</mat-icon>
            </div>
          </div>
          <div class="timeline-empty" *ngIf="getActivitiesByType('RFI').length === 0">No recent RFIs</div>
        </div>
      </div>

      <!-- IQ -->
      <div class="activity-col" *ngIf="canViewRequests()">
        <div class="col-head col-iq"><mat-icon>help_outline</mat-icon><span>IQ</span></div>
        <div class="activity-timeline">
          <div class="timeline-item" *ngFor="let item of getActivitiesByType('IQ')" (click)="navigateToActivity(item)">
            <div class="timeline-dot dot-iq"></div>
            <div class="timeline-card">
              <div class="timeline-card-header">
                <div class="timeline-user" *ngIf="userCache.get(item.createdBy) as user">
                  <img [src]="user.profilePhoto" class="avatar"
                       [routerLink]="['/user-profile', item.createdBy]"
                       (click)="$event.stopPropagation()"
                       [matTooltip]="'View ' + user.username + '\'s profile'">
                  <span class="timeline-name">{{ user.firstname && user.lastname ? user.firstname + ' ' + user.lastname : user.username }}</span>
                </div>
              </div>
              <div class="timeline-body">
                <strong>{{ item.description }}</strong>
                <div class="timeline-meta">
                  <span class="meta-badge meta-date"><mat-icon>schedule</mat-icon>{{ item.activityDate | date:'dd MMM yyyy' }}</span>
                  <span class="meta-badge meta-project"><mat-icon>folder</mat-icon>Proj #{{ item.projectNumber }}</span>
                </div>
              </div>
              <mat-icon class="timeline-chevron">chevron_right</mat-icon>
            </div>
          </div>
          <div class="timeline-empty" *ngIf="getActivitiesByType('IQ').length === 0">No recent IQs</div>
        </div>
      </div>

      <!-- RISKS -->
      <div class="activity-col" *ngIf="canViewRequests()">
        <div class="col-head col-risks"><mat-icon>warning</mat-icon><span>RISKS</span></div>
        <div class="activity-timeline">
          <div class="timeline-item" *ngFor="let item of getActivitiesByType('RISKS')" (click)="navigateToActivity(item)">
            <div class="timeline-dot dot-risks"></div>
            <div class="timeline-card">
              <div class="timeline-card-header">
                <div class="timeline-user" *ngIf="userCache.get(item.createdBy) as user">
                  <img [src]="user.profilePhoto" class="avatar"
                       [routerLink]="['/user-profile', item.createdBy]"
                       (click)="$event.stopPropagation()"
                       [matTooltip]="'View ' + user.username + '\'s profile'">
                  <span class="timeline-name">{{ user.firstname && user.lastname ? user.firstname + ' ' + user.lastname : user.username }}</span>
                </div>
              </div>
              <div class="timeline-body">
                <strong>{{ item.description }}</strong>
                <div class="timeline-meta">
                  <span class="meta-badge meta-date"><mat-icon>schedule</mat-icon>{{ item.activityDate | date:'dd MMM yyyy' }}</span>
                  <span class="meta-badge meta-project"><mat-icon>folder</mat-icon>Proj #{{ item.projectNumber }}</span>
                </div>
              </div>
              <mat-icon class="timeline-chevron">chevron_right</mat-icon>
            </div>
          </div>
          <div class="timeline-empty" *ngIf="getActivitiesByType('RISKS').length === 0">No recent RISKS</div>
        </div>
      </div>

      <!-- EWOs activity column (COMMENTED OUT)
      <div class="activity-col" *ngIf="canViewEwos()">
        <div class="col-head col-ewos"><mat-icon>construction</mat-icon><span>EWOs</span></div>
        <div class="activity-timeline">
          <div class="timeline-item" *ngFor="let item of getActivitiesByType('EWO')" (click)="navigateToActivity(item)">
            <div class="timeline-dot"></div>
            <div class="timeline-card">
              <div class="timeline-user" *ngIf="userCache.get(item.createdBy) as user">
                <img [src]="user.profilePhoto" class="avatar"
                     [routerLink]="['/user-profile', item.createdBy]"
                     (click)="$event.stopPropagation()"
                     [matTooltip]="'View ' + user.username + '\'s profile'">
                <span class="timeline-name">{{ user.firstname && user.lastname ? user.firstname + ' ' + user.lastname : user.username }}</span>
              </div>
              <div class="timeline-body">
                <strong>{{ item.description }}</strong>
                <div class="timeline-meta">
                  <span class="meta-badge meta-date"><mat-icon>schedule</mat-icon>{{ item.activityDate | date:'dd MMM yyyy' }}</span>
                  <span class="meta-badge meta-project"><mat-icon>folder</mat-icon>Proj #{{ item.projectNumber }}</span>
                </div>
              </div>
              <mat-icon class="timeline-chevron">chevron_right</mat-icon>
            </div>
          </div>
          <div class="timeline-empty" *ngIf="getActivitiesByType('EWO').length === 0">No recent EWOs</div>
        </div>
      </div>
      -->
    </div>

    <ng-template #noActivity>
      <div class="empty-state">
        <div class="empty-state-icon"><mat-icon>inbox</mat-icon></div>
        <p class="empty-state-title">No Recent Activity</p>
        <p class="empty-state-sub">Activity from your projects will appear here</p>
      </div>
    </ng-template>
  </section>

</div>

<!-- Response Rate Modal -->
<div class="modal-backdrop" *ngIf="showResponseRateModal" (click)="showResponseRateModal = false"></div>
<div class="modal-dialog" *ngIf="showResponseRateModal" (click)="$event.stopPropagation()">
  <div class="modal-content">
    <div class="modal-header">
      <h3><mat-icon>speed</mat-icon> Response Rate</h3>
      <button class="close-btn" (click)="showResponseRateModal = false"><mat-icon>close</mat-icon></button>
    </div>
    <div class="modal-body">
      <p class="modal-description">The response rate measures the percentage of requests that have progressed beyond the initial "Action Required" stage. A higher rate indicates faster team responsiveness.</p>

      <div class="rate-stats">
        <div class="rate-stat-row">
          <span class="rate-stat-label">Total Requests</span>
          <span class="rate-stat-value">{{ totalRequestCount }}</span>
        </div>
        <div class="rate-stat-row">
          <span class="rate-stat-label">Responded (Acknowledged + In Progress + Complete)</span>
          <span class="rate-stat-value">{{ stageAcknowledgedCount + stageInProgressCount + stageCompleteCount }}</span>
        </div>
        <div class="rate-stat-row">
          <span class="rate-stat-label">Awaiting Response (Action Required)</span>
          <span class="rate-stat-value">{{ stageActionRequiredCount }}</span>
        </div>
        <div class="rate-stat-divider"></div>
        <div class="rate-stat-row rate-stat-highlight">
          <span class="rate-stat-label">Response Rate</span>
          <span class="rate-stat-value">{{ responseRate }}%</span>
        </div>
      </div>

      <div class="rate-breakdown">
        <h4>Stage Breakdown</h4>
        <div class="rate-bar-row">
          <span class="rate-bar-label">Action Required</span>
          <div class="rate-bar-track"><div class="rate-bar-fill bar-action" [style.width.%]="getStagePercentage(stageActionRequiredCount)"></div></div>
          <span class="rate-bar-count">{{ stageActionRequiredCount }}</span>
        </div>
        <div class="rate-bar-row">
          <span class="rate-bar-label">Acknowledged</span>
          <div class="rate-bar-track"><div class="rate-bar-fill bar-ack" [style.width.%]="getStagePercentage(stageAcknowledgedCount)"></div></div>
          <span class="rate-bar-count">{{ stageAcknowledgedCount }}</span>
        </div>
        <div class="rate-bar-row">
          <span class="rate-bar-label">In Progress</span>
          <div class="rate-bar-track"><div class="rate-bar-fill bar-prog" [style.width.%]="getStagePercentage(stageInProgressCount)"></div></div>
          <span class="rate-bar-count">{{ stageInProgressCount }}</span>
        </div>
        <div class="rate-bar-row">
          <span class="rate-bar-label">Complete</span>
          <div class="rate-bar-track"><div class="rate-bar-fill bar-done" [style.width.%]="getStagePercentage(stageCompleteCount)"></div></div>
          <span class="rate-bar-count">{{ stageCompleteCount }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
